import { render } from "./BuyInOffer.vue?vue&type=template&id=70da36b3&scoped=true"
import script from "./BuyInOffer.vue?vue&type=script&lang=js"
export * from "./BuyInOffer.vue?vue&type=script&lang=js"

import "./BuyInOffer.vue?vue&type=style&index=0&id=70da36b3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70da36b3"]])

export default __exports__